import { Component, OnInit } from '@angular/core';
import packageSearchData from  "../mockdata/packageSearch.json";

@Component({
  selector: 'cmpts-package-search',
  templateUrl: './package-search.component.html',
  styleUrls: ['./package-search.component.css']
})
export class PackageSearchComponent implements OnInit {
  packageDatas = packageSearchData;
  constructor() { }

  ngOnInit(): void {
  }

}
